"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var daysOfWeek = {
    MONDAY: date_fns_1.isMonday,
    TUESDAY: date_fns_1.isTuesday,
    WEDNESDAY: date_fns_1.isWednesday,
    THURSDAY: date_fns_1.isThursday,
    FRIDAY: date_fns_1.isFriday,
    SATURDAY: date_fns_1.isSaturday,
    SUNDAY: date_fns_1.isSunday,
};
var dayNameToIndex = {
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
    SUNDAY: 7,
};
var getCurrentDay = function () {
    var _a;
    var day = new Date().getUTCDay();
    return (_a = Object.entries(dayNameToIndex).find(function (_a) {
        var index = _a[1];
        return index === (day === 0 ? 7 : day);
    })) === null || _a === void 0 ? void 0 : _a[0];
};
var getDaysUntilNextActive = function (activeDays) {
    var now = new Date();
    var todayIndex = now.getUTCDay() === 0 ? 7 : now.getUTCDay();
    var activeIndexes = activeDays.map(function (day) { return (typeof day === 'number' ? day : dayNameToIndex[day]); });
    var sorted = activeIndexes.sort(function (a, b) { return a - b; });
    for (var _i = 0, sorted_1 = sorted; _i < sorted_1.length; _i++) {
        var index = sorted_1[_i];
        if (index > todayIndex)
            return index - todayIndex;
    }
    return 7 - todayIndex + sorted[0];
};
var checkPromoDay = function (weekDays) {
    if (!weekDays || weekDays.length === 0) {
        return { active: true };
    }
    var currentDay = getCurrentDay();
    var todayIndex = dayNameToIndex[String(currentDay)];
    var hasToday = weekDays.some(function (day) { return day === currentDay || day === todayIndex; });
    if (hasToday)
        return { active: true };
    var daysUntilNext = getDaysUntilNextActive(weekDays);
    var now = new Date();
    var nextUtcMidnight = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + daysUntilNext, 0, 0, 0, 0));
    return {
        active: false,
        startAt: nextUtcMidnight.toISOString(),
    };
};
exports.default = checkPromoDay;
